import kr from '../kr/kr';

export default class VideoAutoplay extends kr.Component {
    init() {
        this._fakePoster = document.querySelector('.homepage-slider__main');
        this.createVideo();
    }
    createVideo() {
        this._fakePoster.addEventListener('click', ()=> {
            this._video();
        });

        if (window.innerWidth > 767) {
            this._video();
        };
    }

    _video()
    {
        const videoContainer = document.querySelector('.homepage-slider__video-container');
        let videoElement = document.createElement('video');
        videoElement.setAttribute('class', 'homepage-video');
        videoElement.setAttribute('id', 'homepage-video');
        videoContainer.appendChild(videoElement);
        videoElement.setAttribute('loop', '');
        videoElement.muted = true;
        videoElement.src = this.$element.getAttribute('data-video');
        videoElement.autoplay = true;

        this._fakePoster.remove();
        videoElement.load();
        /*videoElement.addEventListener('loadeddata', () => {
            videoElement.play();
            //console.log('load');
        }, false);*/
    }
}

kr.registerComponent('.homepage-slider__video-container', {
    component: VideoAutoplay
});